module.exports = __webpack_public_path__ + "static/img/qudi (4).35022d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (4).jpg
// module id = g5ru
// module chunks = 0